import { XML_TYPE } from 'Utilities'
import axios from 'axios'
import * as FileSaver from 'file-saver'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function getMassiveUploadTemplate() {
  try {
    const { data: fileBuffer } = await axios.get(`${LEADS_ENDPOINT}/getMassiveUploadTemplate`, {
      method: 'GET',
      responseType: 'blob',
      timeout: 20000,
    })
    
    const file = new Blob([fileBuffer], { type: XML_TYPE })
    FileSaver.saveAs(file, 'CargaMasivaLeads.xlsx')
  } catch (error) {
    return error
  }
}
